import api from './api';
import type { CartItem } from '../types';

export interface CartResponse {
  items: CartItem[];
  updated_at: string | null;
}

export const cartService = {
  /** Carica il carrello dell'utente corrente da MongoDB. */
  getCart: async (): Promise<CartResponse> => {
    const { data } = await api.get<CartResponse>('/api/clienti/me/cart');
    return data;
  },

  /** Sincronizza l'intero carrello (sostituzione completa). */
  syncCart: async (items: CartItem[]): Promise<CartResponse> => {
    const { data } = await api.put<CartResponse>('/api/clienti/me/cart', { items });
    return data;
  },

  /** [Admin] Legge il carrello di un cliente tramite an_conto. */
  adminGetCart: async (anConto: number): Promise<CartResponse> => {
    const { data } = await api.get<CartResponse>(`/api/admin/clienti/${anConto}/cart`);
    return data;
  },
};
